import { render, staticRenderFns } from "./account-edit-detail.vue?vue&type=template&id=b40ca150&"
import script from "./account-edit-detail.vue?vue&type=script&lang=js&"
export * from "./account-edit-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports